import { IAppTheme } from 'types/AppTheme';
import { cssVariables } from './variables';

export const DEFAULT_THEME: IAppTheme = {
  cssVariables,
  colors: {
    accentColor: '#ff6b37',
    brandColor: '#000000',
    backgroundHoverAccentColor: 'transparent',
    hoverAccentColor: 'transparent',
    backgroundHoverBrandColor: 'transparent',
    hoverBrandColor: 'transparent',
    textBrandColor: '#ffffff',
    textAccentColor: '#ffffff',
  },
};

export const HOVER_DARKEN = 0.1;
export const ACTIVE_DARKEN = 0.04;
export const SEPARATOR_OPACITY = 0.1;
export const FOCUS_OPACITY = 0.4;
export const ACTIVE_OPACITY = 0.045;
export const HOVER_OPACITY = 0.06;
export const HOVER_ACCENT_OPACITY = 0.03;
export const ACTIVE_ACCENT_OPACITY = 0.15;
export const BRAND_MIX_DISABLED_TEXT = 0.15; // 15% brand color, 85% dark-gray
export const ACCENT_MIX_DISABLED_TEXT = 0.1; // 10% accent color, 90% dark-gray
export const OPACITY_RELAXED_BASE = 0.1;
export const OPACITY_RELAXED_HOVER = 0.2;
export const OPACITY_RELAXED_ACTIVE = 0.14;
